import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlaceCategoryIds = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['categoryIds'] => getPlace(placeKey)(store).categoryIds;
